export default {
  getMap(state) {
    return state.map;
  },
  isCarregado(state) {
    return state.spacialMath && state.clustering;
  },
  getPinsFetchURL(state) {
    return state.pinsData;
  },
  getMapsAPI(state) {
    return state.mapsAPI;
  },
  getMapOptions(state) {
    return state.mapOptions;
  },
  getZoomInicial(state) {
    return state.zoomInicial;
  },
};
